import { Default, NoStore } from "./default";

// import "antd/dist/antd.min.css";


export const theme = {
	Default,
	NoStore,
};
